@if (actual) {
<article
  class="alianza-hub-card"
  [attr.aria-roledescription]="mostrarCarrusel ? 'carrusel' : null"
  (mouseenter)="onCarruselPause()"
  (mouseleave)="onCarruselResume()"
  (focusin)="onCarruselFocusIn()"
  (focusout)="onCarruselFocusOut()"
>
  <div
    class="alianza-hub-card__fade"
    [class.alianza-hub-card__fade--out]="!fade.visible"
  >
    <div class="alianza-hub-card__content">
      <div class="alianza-hub-card__quipu">
        @if (actual.urlLogo) {
        <img
          class="alianza-hub-card__logo"
          [src]="actual.urlLogo"
          [alt]="actual.nombre"
          width="64"
          height="64"
        />
        } @else {
        <span class="alianza-hub-card__logo alianza-hub-card__logo--empty" aria-hidden="true"></span>
        }

        <div class="alianza-hub-card__txt">
          <h2 class="alianza-hub-card__nombre">{{ actual.nombre }}</h2>
          <p class="alianza-hub-card__desc" [innerHTML]="html(actual.descripcion)"></p>
        </div>
      </div>

      @if (actual.bullets.length) {
      <ul class="alianza-hub-card__bullets">
        @for (bullet of actual.bullets; track $index) {
        <li>
          <span class="alianza-hub-card__bullet-dot" aria-hidden="true"></span>
          <span class="alianza-hub-card__bullet-text">{{ bullet }}</span>
        </li>
        }
      </ul>
      }
    </div>

    <button
      type="button"
      class="alianza-hub-card__cta"
      id="btn-alianza-hub-cta"
      [disabled]="!actual.urlForward"
      (click)="onCta()"
    >
      {{ actual.nombreBoton }}
    </button>
  </div>

  @if (mostrarCarrusel) {
  <div class="alianza-hub-card__dots" role="tablist" aria-label="Aliados">
    @for (item of alianzas; track $index; let i = $index) {
    <button
      type="button"
      class="alianza-hub-card__dot"
      role="tab"
      [class.alianza-hub-card__dot--activo]="i === indice"
      [attr.aria-selected]="i === indice"
      [attr.aria-label]="'Aliado ' + (i + 1)"
      (click)="irA(i)"
    ></button>
    }
  </div>
  }
</article>
}
